import { Link } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import { pages } from '../../../config';
import Button from '../Button';
import errorSrc from './images/error.svg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  min-height: 100vh;
  background: var(--earth-fm--color--green);
  text-align: center;

  img {
    width: 100%;
    max-width: 240px;
    height: auto;
  }

  @media (min-width: 992px) {
    img {
      max-width: none;
      width: 360px;
    }
  }
`;

const Message = styled.p`
  max-width: 640px;
  margin: 18px auto clamp(20px, 15vh, 128px);
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
  color: var(--earth-fm--color--yellow);
  text-align: center;
`;

interface Props {
  message?: React.ReactNode;
}

export default function ErrorScreen({ message = 'Uh-oh, something went wrong!' }: Props) {
  return (
    <Wrapper>
      <div className="container">
        <img src={errorSrc} alt="" />
        <Message>{message}</Message>
        <Button as={Link} to={pages.home}>
          Go home
        </Button>
      </div>
    </Wrapper>
  );
}
